angular.module('app') .directive('dontCloseMenu', function ($parse, $rootScope) { 
    return { 
        restrict: 'AC',
        link: function(scope, element, attrs) { 
            element.find('button').attr('md-prevent-menu-close', 'md-prevent-menu-close'); 
        } 
    };
});
